'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var omitPropNames = ['render', 'condition'];

var propTypes = exports.propTypes = {
  render: _propTypes2.default.func,
  children: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.node]),
  on: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]).isRequired,
  run: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)])
};

var Verifier = function Verifier(props) {
  var render = props.render,
      run = props.run,
      on = props.on,
      condition = props.condition,
      children = props.children;

  var childProps = (0, _lodash.omit)(props, omitPropNames);

  if (!condition(on, run)) return _react2.default.createElement('span', null);

  if (render) return render(childProps);

  if (typeof children === 'function') return children(childProps);

  return children ? _react.Children.only(children) : null;
};

Verifier.propTypes = Object.assign({
  condition: _propTypes2.default.func.isRequired
}, propTypes);

exports.default = Verifier;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@mayo/user-permissions/lib/Verifier.js
 ** module id = 256
 ** module chunks = 0
 **/